import { Modal } from "tailwindcss-stimulus-components"

export default class extends Modal {

    open(e) {
        super.open(e);
        // set focus to the first input element
        this.element.querySelector('input').focus();
    }
}